<div class="next">
  <ng-content></ng-content>
</div>
<div class="d-md-none mobile-container text-center">
  <div class="row">
    <div class="col-12 description">{{ nextStep | translate }}</div>
    <div *ngIf="isCanSubmit" class="col-12">
      <div class="next">
        <button [disabled]="disabled" class="btn btn-primary" (click)="onSubmit()">{{ title | translate }}</button>
      </div>
    </div>
    <div class="col-12" *ngIf="isSkip">
      <div class="">
        <button class="btn btn-outline-primary skip skip-btn" (click)="onSkip()">{{ skipTitle | translate }}</button>
      </div>
    </div>
  </div>
</div>
<div class="d-none d-md-block white-container">
  <div class="container">
    <div class="row">
      <div class="col-md-4" *ngIf="isSkip">
        <div class="">
          <button class="btn btn-outline-primary skip skip-btn" (click)="onSkip()">{{ skipTitle | translate }}</button>
        </div>
      </div>
      <div class="col-md-4 text-center" [ngClass]="{ 'offset-md-4': !isSkip }">{{ nextStep | translate }}</div>
      <div *ngIf="isCanSubmit" class="col-md-4 col-12 text-md-right" [ngClass]="{ 'col-md-12': isCentered }">
        <div class="next">
          <button [disabled]="disabled" class="btn btn-primary" (click)="onSubmit()">{{ title | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
